import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import store from "@/store";
import {IdMapper} from "@/interfaces/state/base";
import {Contact} from "@/interfaces/entity";
import {PaginationMeta} from "@/interfaces/common";
import {createContact, singleContact, editContact, deleteContact, listContacts} from "@/modules/contact/services";
import {ContactState} from "@/interfaces/state/contact";
import {ContactParams} from "@/modules/contact/params";

@Module({ dynamic: true, name: "contacts", store })
class ContactModule extends VuexModule implements ContactState {
    data: IdMapper<Contact> = {};
    ids: number[] = [];
    meta: PaginationMeta = new PaginationMeta();
    params: ContactParams = new ContactParams();

    @Mutation
    private MAP_CONTACTS(payload: any) {
        const idMapper = {} as any;
        this.meta = payload.meta;
        this.ids = payload.datas.map((contact: Contact, index: number) => {
            idMapper[contact.id] = { ...contact, stt: index + 1 };
            return contact.id;
        })
        this.data = idMapper;
    }

    @Mutation
    private UPDATE_PARAMS_CONTACT(payload: any) {
        this.params = payload;
    }

    @Mutation
    private DELETE_CONTACT(payload: any) {
        this.ids = this.ids.filter((id: number) => id !== payload);
        delete this.data[payload];
    }

    @Action({ rawError: true })
    public async createContact(payload: any) {
        await createContact(payload);
    }

    @Action({ rawError: true })
    public async singleContact(payload: any) {
        const { data } = await singleContact(payload);
        return data.data;
    }

    @Action({ rawError: true })
    public async editContact(payload: any) {
        await editContact(payload.id, payload);
    }

    @Action({ rawError: true })
    public async deleteContact(payload: any) {
        await deleteContact(payload);
        this.DELETE_CONTACT(payload);
    }

    @Action({ rawError: true })
    public async listContacts(params: any) {
        const { data } = await listContacts(params);
        console.log(data);
        this.MAP_CONTACTS(data);
    }

    @Action({ rawError: true })
    public updateParams(payload: any) {
        this.UPDATE_PARAMS_CONTACT(payload);
    }
}

export const ContactStore = getModule(ContactModule);